import { render, staticRenderFns } from "./PreviousCourses.vue?vue&type=template&id=3aab8782"
import script from "./PreviousCourses.vue?vue&type=script&lang=js"
export * from "./PreviousCourses.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports